import React from 'react'
import './logo.scss'

const Logo = () => {
    return (
        <section className='logo_bg'>
            <div className="custom-container logo_main">
                <div className="logo_heading">
                    <h3 className='brand_common_heading'>Logo</h3>
                    <a href='/assets/brandassets/logo.zip' className='brand__button' download>Download All</a>
                </div>
                <div className="logo_grid">
                    <div className="logo_grid_child">
                        <img className='rain-dark' src="/assets/brandassets/logo/rain-complete.svg" alt="logo" />
                        <div className="png-svg">
                            <a href='/assets/brandassets/logo/rain-complete.png' className="png" download>PNG</a>
                            <a href='/assets/brandassets/logo/rain-complete.svg' className="png" download>SVG</a>
                        </div>
                    </div>
                    <div className="logo_grid_child logo_grid_child_two">
                        <img src="/assets/brandassets/logo/rain.svg" alt="logo" />
                        <div className="png-svg">
                            <a href='/assets/brandassets/logo/rain.png' className="png" download>PNG</a>
                            <a href='/assets/brandassets/logo/rain.svg' className="png" download>SVG</a>
                        </div>
                    </div>
                    <div className="logo_grid_child logo_grid_child_light">
                        <img className='rain-light' src="/assets/brandassets/logo/rain-complete-light.svg" alt="logo" />
                        <div className="png-svg">
                            <a href='/assets/brandassets/logo/rain-complete-light.png' className="png_light" download>PNG</a>
                            <a href='/assets/brandassets/logo/rain-complete-light.svg' className="png_light" download>SVG</a>
                        </div>
                    </div>
                    <div className="logo_grid_child logo_grid_child_light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="74" height="74" viewBox="0 0 74 74" fill="none">
                            <circle cx="37" cy="37" r="37" fill="#212121" />
                            <path d="M36.749 7.40002C38.2194 29.8926 63.5458 26.9697 63.5458 37.004C63.5458 45.1848 51.5153 49.5692 36.6688 49.5692C21.8222 49.5692 9.79168 45.1848 9.79168 37.004C9.78277 26.9697 35.1092 29.8926 36.5886 7.40002C19.4339 7.44458 5.5498 20.7227 5.5498 37.111C5.5498 53.4992 19.4785 66.8219 36.6688 66.8219C53.859 66.8219 67.7877 53.517 67.7877 37.111C67.7877 20.7049 53.8947 7.44458 36.749 7.40002Z" fill="#E6FF00" />
                        </svg>
                        <div className="png-svg">
                            <a href='/assets/brandassets/logo/rain-light.png' className="png_light" download>PNG</a>
                            <a href='/assets/brandassets/logo/rain-light.svg' className="png_light" download>SVG</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Logo